class GlobalConfigs {
  get VERSION() {
    return "1";
  }
  get API_URL() {
    return process.env.REACT_APP_APIHOSTURL
  }
  get IMAGE_URL() {
    return process.env.REACT_APP_IMAGE_URL
  }
  get PDF_URL()
  {
    return process.env.REACT_APP_ADMIN_PDF_URL
  }
  get EXCEL_URL()
  {
    return process.env.REACT_APP_SCHOOL_EXCEL
  }
  get EXCEL_SAMPLE_QUESTIONS()
  {
    return process.env.REACT_APP_SAMPLE_QUESTIONS
  }
  get SAMPLE_CSS()
  {
    return process.env.REACT_APP_SAMPLE_CSS
  }
  get RESUME()
  {
    return process.env.REACT_APP_RESUME_BASE
  }
  get TINY_API_KEY()
  {
    return "jardz48vynm4404gay8da5jbh4kxezqa582leydxczhaimle"
  }
}

const globalConfigs = new GlobalConfigs();

export default globalConfigs;
